import { NoneOrderTagDetailResponse } from "apis/data-contracts";
import Label from "components/foundation/Label/Label";
import React from "react";
import styled from "styled-components";

interface DocumentTagListProps {
  docTags?: Record<string, (string | NoneOrderTagDetailResponse)[]>;
  actions?: React.ReactNode;
}

const DocumentTagList = ({ docTags = {}, actions }: DocumentTagListProps) => {
  const tagRows = Object.keys(docTags);

  return (
    <TagSectionStyle>
      <MobileTagSectionTitle className="mobile-only">
        <h3>문서 태그</h3>
        <div>{actions}</div>
      </MobileTagSectionTitle>

      <TagListStyle>
        {tagRows.map((row, index) => {
          const tags = docTags[row];
          return (
            <TagRow key={`${row}-${index}`} title={row}>
              {tags.map((tag) => {
                let key;
                let tagName;

                if (typeof tag === "string") {
                  key = tag;
                  tagName = tag;
                } else {
                  key = tag?.tagUuid;
                  tagName = tag?.tagName;
                }

                return (
                  <Label key={key} variant="grey">
                    {tagName}
                  </Label>
                );
              })}
            </TagRow>
          );
        })}
      </TagListStyle>

      <div className="pc-only">{actions}</div>
    </TagSectionStyle>
  );
};

export default DocumentTagList;

interface TagRowProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
}

const TagRow = ({ title, children, ...rest }: TagRowProps) => {
  return (
    <TagRowWrapStyle {...rest}>
      <TagRowTitleStyle>{title}</TagRowTitleStyle>
      <TagRowChildrenStyle>{children}</TagRowChildrenStyle>
    </TagRowWrapStyle>
  );
};

/* 스타일 */
export const TagSectionStyle = styled.section`
  display: flex;
  padding: 2.6rem 3rem 3rem 3rem;
  align-items: flex-start;
  gap: 0.8rem;

  background: ${({ theme }) => theme.color.background.default};
  border-radius: 2rem;

  ${({ theme }) => theme.media.small} {
    padding: 1.6rem 1.6rem 2.4rem 1.6rem;
    flex-direction: column;
  }
`;

export const MobileTagSectionTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    ${({ theme }) => theme.typography.body3.semibold}
  }
`;

export const TagListStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  flex: 1;
`;

/* TagRow */
export const TagRowWrapStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  ${({ theme }) => theme.media.small} {
    gap: 2rem;
  }
`;

export const TagRowTitleStyle = styled.div`
  width: 17.7rem;
  ${({ theme }) => theme.typography.body1.regular}
  letter-spacing: -0.048rem;

  ${({ theme }) => theme.media.small} {
    width: 6.2rem;
    ${({ theme }) => theme.typography.body3.regular}
  }
`;

export const TagRowChildrenStyle = styled.div`
  display: inline-flex;
  gap: 0.8rem;
`;
